import { GetWorkflowRequestDetailsContract } from 'schemas/GetWorkflowRequestDetails';

export function getPeopleDataByPeopleId(
  peopleMetaData: GetWorkflowRequestDetailsContract['people_metadata'],
  peopleId: string,
) {
  return peopleMetaData[peopleId];
}
